/**
 * @generated SignedSource<<1bda6d36068ab3fd9b94dd3f302dbc32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TerminateSubscriptionInput = {
  id: string;
};
export type TerminateSubscriptionDialogMutation$variables = {
  input: TerminateSubscriptionInput;
};
export type TerminateSubscriptionDialogMutation$data = {
  readonly terminateSubscription: {
    readonly expiresAt: any | null | undefined;
    readonly id: string;
    readonly state: string;
  };
};
export type TerminateSubscriptionDialogMutation = {
  response: TerminateSubscriptionDialogMutation$data;
  variables: TerminateSubscriptionDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Subscription",
    "kind": "LinkedField",
    "name": "terminateSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TerminateSubscriptionDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TerminateSubscriptionDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e990cbb5a4e4dc143300b8c75d817ff2",
    "id": null,
    "metadata": {},
    "name": "TerminateSubscriptionDialogMutation",
    "operationKind": "mutation",
    "text": "mutation TerminateSubscriptionDialogMutation(\n  $input: TerminateSubscriptionInput!\n) {\n  terminateSubscription(input: $input) {\n    id\n    state\n    expiresAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "114c1b40353873d81d0f5c3b15dc0967";

export default node;
